import { removeCustomerSourceHeaderFromStorage } from './customerSourceStorage';

const AFFILIATE_TOKEN_HEADER = 'x-affiliate-token';

// TODO: not sure do we need that now
// function removeCurrentUrlSourceTokenParams(): void {
//   if (typeof window === 'undefined') {
//     return;
//   }

//   try {
//     const url = new URL(window.location.href);
//     const hadSourceTokenParam = url.searchParams.has(ANALYTIC_SOURCE_PARAM.Token)
//       || url.searchParams.has(ANALYTIC_SOURCE_PARAM.AffiliateToken);

//     if (!hadSourceTokenParam) {
//       return;
//     }

//     url.searchParams.delete(ANALYTIC_SOURCE_PARAM.Token);
//     url.searchParams.delete(ANALYTIC_SOURCE_PARAM.AffiliateToken);

//     window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
//   } catch {
//     // Ignore URL cleanup errors; storage cleanup is enough for normal navigation.
//   }
// }

export function clearUsedAffiliateTokenSource(): void {
  removeCustomerSourceHeaderFromStorage(AFFILIATE_TOKEN_HEADER);
  // removeCurrentUrlSourceTokenParams();
}
